//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"CategorySelector",1,0],[0,"FLPSelector",1,0],[0,"PropertySelector",1,0],[0,"SelectClassification",1,"AME.SelectClassificationBuilder",0],[0,"SelectLibraryObject",0,"AME.SelectionBaseDefinitionBuilder",0]],[],[]];
SPLM.AME.AddPlaceholderBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AddPlaceholderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.AddPlaceholderBuilder.Category = Object.freeze({
    "Objects" : "Objects", "ObjectPortsA" : "ObjectPortsA", "ObjectPortsB" : "ObjectPortsB", "ObjectParents" : "ObjectParents", "Connections" : "Connections", "ConnectionParents" : "ConnectionParents", "ConnectionsA" : "ConnectionsA", "ConnectionParentsA" : "ConnectionParentsA", "ConnectionsB" : "ConnectionsB", "ConnectionParentsB" : "ConnectionParentsB", "Sources" : "Sources", "SourcePorts" : "SourcePorts", "SourceParents" : "SourceParents", "Targets" : "Targets", "TargetPorts" : "TargetPorts", "TargetParents" : "TargetParents", "TargetsA" : "TargetsA", "TargetPortsA" : "TargetPortsA", "TargetParentsA" : "TargetParentsA", "TargetsB" : "TargetsB", "TargetPortsB" : "TargetPortsB", "TargetParentsB" : "TargetParentsB", "Placeholder" : "Placeholder", "MatrixConnectionsA" : "MatrixConnectionsA", "MatrixConnectionsB" : "MatrixConnectionsB", "MatrixConnectionParentsA" : "MatrixConnectionParentsA", "MatrixConnectionParentsB" : "MatrixConnectionParentsB", "MatrixPlaceholder" : "MatrixPlaceholder"});

SPLM.AME.AddPlaceholderBuilder.Flp = Object.freeze({
    "Function" : "Function", "Location" : "Location", "Product" : "Product", "Automation" : "Automation"});

SPLM.AME.AddPlaceholderBuilder.Property = Object.freeze({
    "Type" : "Type", "Product" : "Product", "ProductOrType" : "ProductOrType", "General" : "General", "Aspect" : "Aspect", "Page" : "Page", "Tag" : "Tag"});

SPLM.AME.AddPlaceholderBuilder.ContentPropertyType = Object.freeze({
    "Value" : "Value", "Sum" : "Sum"});

export default SPLM;